<template lang="html">
	<section class="block">
		<h3>{{ $t(`${sector}.${abast}.products.title`) }}</h3>
		<p v-if="isReportEditable" class="note">{{ $t(`${sector}.${abast}.products.desc`) }}</p>
		<emissions-table v-if="!skip" v-model="emissions" :editable="isReportEditable">
			<template v-slot:header>
				<th>{{ $t('report.table.concept') }}</th>
				<th>{{ $t('report.table.group') }}</th>
				<th>
					<span :data-tooltip-alert="$t('tooltip.all_products')">
						<i class="mdi mdi-alert-circle icon icon--emphasis" />
					</span>
					{{ $t('report.table.product') }}
				</th>
				<th>{{ $t('report.table.qty') }}</th>
			</template>
			<template v-slot:body="{ item }">
				<td>{{ item.concept }}</td>
				<td>{{ item.group.label }}</td>
				<td>{{ item.resource.label }}</td>
				<td>{{ item.qty }}<em class="unit">{{ item.resource.unit }}</em></td>
			</template>
			<template v-slot:insert="{ insert }">
				<td>
					<input
						type="text"
						class="long"
						v-model="insert.concept"
						:placeholder="$t(`${sector}.${abast}.products.example`)" />
				</td>
				<td>
					<dropdown-select
						:options="PRODUCTS"
						v-model="insert.group"
						:placeholder="$t('report.table.group')" />
				</td>
				<td :data-tooltip="insert.group ? false : $t('tooltip.require.category')">
					<dropdown-select
						v-model="insert.resource"
						:disabled="!insert.group"
						:options="insert.group ? insert.group.items : []"
						:placeholder="$t('report.table.product')" />
				</td>
				<td :data-tooltip="isEmpty(insert.resource)
					? $t('tooltip.require.product')
					: $t('tooltip.unit_in', { unit: insert.resource.unit })">
					<input
						v-model.number="insert.qty"
						:disabled="isEmpty(insert.resource)"
						:placeholder="isEmpty(insert.resource)
							? $t('report.table.qty')
							: insert.resource.unit"
						type="number"
						min="0"
						step="0.1" />
				</td>
			</template>
		</emissions-table>
		<p v-if="isSkipperVisible">
			<label>
				<input type="checkbox" v-model="skip" :disabled="!isReportEditable" />
				{{ $t('global.tip.skip') }}
			</label>
		</p>
	</section>
</template>

<script>
import StepBlockMixin from '@/mixins/StepBlockMixin';
import EmissionsTable from '@/components/EmissionsTable.vue';
import DropdownSelect from '@/components/DropdownSelect.vue';
import { isEmpty } from '@/utils';
import PRODUCTS from '@/assets/constants/products';

export default {
	name: 'StepProducts',
  keyBlock: 'products',
	mixins: [StepBlockMixin],
	components: { EmissionsTable, DropdownSelect },
	data() {
		return { PRODUCTS };
	},
	methods: { isEmpty },
};
</script>
